<template>
    <div class="container">
        <div class="row justify-content-center my-3">
            <div class="col-12 col-lg-9 my-1">
                <h1>Credits</h1>
                <p>
                </p>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item"><a href="https://discord.com/channels/756525751594909797/785498701447430175">Cygnoux Familia</a></li>
                    <li class="list-group-item"><a href="https://www.reddit.com/user/cadelsec/">cadelsec</a></li>
                    <li class="list-group-item"><a href="https://www.reddit.com/user/JamesPTW13">JamesPTW13</a></li>
                    <li class="list-group-item"><a href="https://www.reddit.com/user/ItsJustAlexis1">ItsJustAlexis1</a></li>
                    <li class="list-group-item"><a href="https://www.reddit.com/user/ShootingStarsCODM">ShootingStarsCODM</a></li>
                    <li class="list-group-item"><a href="https://www.reddit.com/user/Valeriu99">Valeriu99</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style>
</style>